import { Plan } from 'types/plan';

export function convertPlanDays(
  days: number,
  fromPlan: Plan,
  toPlan: Plan,
): number {
  if (fromPlan.id === toPlan.id) {
    return days;
  }
  const priceRatio = fromPlan.priceYearly / toPlan.priceYearly;
  const convertedDays = Math.round(days * priceRatio);

  return convertedDays;
}
